$(function(){

  // 現在時刻をサーバーから取得
  illm.common.getServerDate().then( date => {
    
    //メインビジュアルの制御
    illm.mainvisual.controlDisplay( date );

    //メインビジュアルのスライダー
    illm.mainvisual.slider();
    
  })

});

illm.mainvisual = {};

/*
 * メインビジュアルの制御
 * @param date サーバー時間
 */
illm.mainvisual.controlDisplay = function( date ){
  const currentTime = date.getTime()/1000;//1970年1月1日 00:00:00から経過した時間を秒単位に変換（UNIX時間）
  
  //メインビジュアルの数だけ処理
  $( '.illm-mvslider-item' ).each( function(){
    const fromDate = $( this ).find( '.illm-js-from-date' ).html();//セクションで設定した表示開始日時のunix時間に変換後の時間
    const toDate = $( this ).find( '.illm-js-to-date' ).html();//セクションで設定した表示終了日時の〃

    //どちらの日時も設定されてない場合は、表示
    if( fromDate === '' && toDate === '' ) return;

    // 終了日時のみ設定されている場合
    else if( fromDate === ''){
      //超えていたら、バナー非表示
      if( currentTime > toDate ) $( this ).remove();
      
    // 開始日時のみ設定されている場合
    } else if ( toDate === '' ) {
      //開始前なら、バナー非表示
      if( currentTime < fromDate ) $( this ).remove();

    //開始前または、終了日時を経過している場合は非表示
    } else if( currentTime < fromDate || currentTime > toDate ){
       $( this ).remove();
    }
  });
}

/*
 * メインビジュアルのスライダー
 */
illm.mainvisual.slider = function(){
  const slideFade = Boolean($('#illm-slide_fade').attr('date-info'));//true
  const slideAutoplay = Boolean($('#illm-slide_autoplay').attr('date-info'));//true
  const slideAutoplaySpeed = parseInt($('#illm-slide_autoplay_speed').attr('date-info'));//4000ms
  const slideSpeed = parseInt($('#illm-slide_speed').attr('date-info'));//600ms
  const slideArrow = Boolean($('#illm-slide_arrow').attr('date-info'));//true
  const slideDot = Boolean($('#illm-slide_dot').attr('date-info'));//true
  
  $( '.illm-mvslider' ).slick({
    fade: slideFade,
    autoplay: slideAutoplay,
    autoplaySpeed: slideAutoplaySpeed,
    speed: slideSpeed,
    arrows: slideArrow,
    dots: slideDot,
    lazyLoad: 'ondemand',
    infinite: true,
    centerMode: true,
    centerPadding: '0px'
  }).css( 'visibility', 'visible' );

}